// MFC • Social Float — GSAP animations
// - Vertical float per image with custom speed & amplitude
// - Respects prefers-reduced-motion
// - Handles Theme Editor load/unload

(() => {
  if (typeof window === 'undefined') return;

  const prefersReduced = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(root) {
    if (!root || !window.gsap) return;

    const imgs = root.querySelectorAll('.mfc-socialfloat__img');
    const tweens = [];

    if (!prefersReduced()) {
      imgs.forEach((el) => {
        const speed = parseFloat(el.dataset.speed || '10'); // seconds
        const amp   = parseFloat(el.dataset.amp || '16');   // px
        const inv   = el.dataset.invert === 'true';

        const fromY = inv ? amp : -amp;
        const toY   = inv ? -amp : amp;

        const tw = gsap.fromTo(
          el,
          { y: fromY },
          { y: toY, duration: speed, ease: 'none', repeat: -1, yoyo: true }
        );
        tweens.push(tw);
      });
    }

    root._mfcDestroy = () => tweens.forEach((t) => t && t.kill());
  }

  function initAll(container = document) {
    container.querySelectorAll('.mfc-socialfloat[data-section-id]').forEach((root) => {
      if (!root._mfcInited) {
        initSection(root);
        root._mfcInited = true;
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('.mfc-socialfloat');
    if (root && root._mfcDestroy) root._mfcDestroy();
  });
})();
